<template>
  <div>
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-select v-model="query['storer.id']" :options="storers" clearable placeholder="placeholder.storer" @change="refresh"/>
        <vxe-input v-model="query['no']" clearable placeholder="placeholder.orderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['customer.name']" clearable placeholder="placeholder.supplierName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.no']" clearable placeholder="placeholder.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading" @cell-click="({row})=>showDetails(row)">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="order.invoiceTime" sortable title="business.label.invoiceTime" width="170"/>
        <vxe-column :title="refundable?'business.label.returnOrderNo':'business.label.receiptOrderNo'" field="order.no"/>
        <vxe-column :title="refundable?'business.label.returnType':'business.label.receivingType'" field="orderType.name"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:orderStatus}" field="order.orderStatus" title="business.label.orderStatus" width="100"/>
        <vxe-column field="storer.name" title="business.label.storerName" width="200"/>
        <vxe-column field="customer.name" title="business.label.supplierName" width="400"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>
<script>
import { findAll } from '@/api/Api'

export default {
  name: 'ReceiptOrder',
  data() {
    return {
      loading: false,
      data: [],
      query: {
        'storer.id': undefined,
        'no': '',
        'customer.name': '',
        'item.no': '',
        'refundable': this.refundable
      },
      page: 1,
      size: 10,
      contentSize: 0
    }
  },
  activated() {
    this.refresh()
  },
  props: {
    refundable: {
      type: Boolean,
      default: false
    },
    orderStatus: {
      type: Array,
      default: []
    },
    storers: {
      type: Array,
      default: []
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      const args = {
        ...this.query,
        'storer.ids': this.query['storer.id'] ? [this.query['storer.id']] : [],
        'extract': true
      }
      this.loading = true
      findAll('receivingAsnListFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
          if (this.data.length > 0) {
            const row = this.data[0]
            this.$refs.table.setCurrentRow(row)
            this.showDetails(row)
          } else {
            this.clearDetails()
          }
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query['storer.id'] = undefined
      this.query['no'] = ''
      this.query['customer.name'] = ''
      this.query['item.no'] = ''
      this.fetch()
    },
    showDetails(row) {
      this.$emit('showDetails', row)
    },
    clearDetails() {
      this.$emit('clearDetails')
    }
  }
}
</script>